module.exports = __webpack_public_path__ + "static/final-39e9e408c424acb360844bb61428d323.png";